<div class="heading">
  <div class="listMapper tab">
    Networks Mapping
  </div>
</div>
<div class="form_frm ui-g-12">
  <form [formGroup]="regiform">
    <div class="listMapper ui-g-5 ui-g-offset-1">
      <p-multiSelect
        defaultLabel="Choose Networks"
        formControlName="advertiser_id"
        [options]="options"
        [virtualScroll]="true"
        [filter]="true"
      >
      </p-multiSelect>
    </div>

    <div class="listMapper ui-g-3">
      <input
        id="input"
        formControlName="network_name"
        placeholder="Enter Network Name"
        type="text"
        size="30"
        pInputText
      />
      <!-- <p-dropdown
        formControlName="team_id"
        [options]="teamOptions"
        placeholder="Select Team"
        [filter]="true"
      ></p-dropdown> -->
    </div>

    <!-- <div class="listMapper ui-g-2">
      <p-dropdown
        formControlName="category_id"
        [options]="listCategoryOptions"
        placeholder="Select Category"
        [filter]="true"
      ></p-dropdown>
    </div> -->

    <div class="listMapper ui-g-1">
      <button class="submitButton" pButton type="button" (click)="submit()">
        Submit
      </button>
    </div>
    <div class="listMapper ui-g-1">
      <button class="resetButton" pButton type="button" (click)="reset()">
        Reset
      </button>
    </div>
  </form>
</div>

<!-- Table  -->
<div class="listMapperTable">
  <p-table
    #dt
    [(columns)]="cols"
    [value]="data.data"
    [paginator]="true"
    [rows]="20"
    paginatorDropdownAppendTo="body"
    [rowsPerPageOptions]="[10, 20, 50, 100, { showAll: 'All' }]"
    [showCurrentPageReport]="true"
    [globalFilterFields]="allCols"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    [loading]="loading"
    (onColReorder)="saveColumnState(dt)"
    exportFilename="Network-Details"
  >
    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix">
        <div class="p-grid">
          <div class="ui-g-2">
            <input
              field="text"
              pInputText
              size="30"
              placeholder="Search"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              class="tableGlobalSearch"
              (focus)="isGlobalFilter = !isGlobalFilter"
              (focusout)="isGlobalFilter = !isGlobalFilter"
              style="width: auto;"
            />
            <i class="tableGlobalSearch pi pi-search" style=""></i>
          </div>
          <!-- <app-dates
            class="ui-g-5"
            [getDates]="{ start_date: startDate, end_date: endDate }"
            (pullDates)="getDates($event)"
          ></app-dates> -->

          <div class="ui-g-5 ui-g-offset-5 filterExportToggle">
            <div class="ui-g-6 extra_input">
              <p-multiSelect
                class="columnFilter"
                [options]="colFilterOptions"
                [(ngModel)]="cols"
                optionLabel="header"
                selectedItemsLabel="{0} columns selected"
                [style]="{ minWidth: '200px', 'margin-right': '1.5rem' }"
                defaultLabel="Choose Columns"
                (onClick)="saveColumnState(dt)"
              >
              </p-multiSelect>
            </div>

            <div class="ui-g-3 filter_c">
              <button
                field="button"
                pButton
                icon="pi pi-filter"
                iconPos="left"
                label="Filter"
                (click)="isFilter = !isFilter; dt.reset(); filterData(dt)"
              ></button>
            </div>

            <div class="ui-g-3 export_c">
              <button
                field="button"
                pButton
                iconPos="left"
                label="Export"
                (click)="exportData(dt)"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
          [pSortableColumn]="col.field"
          [ngStyle]="{
            width: col.type === 'any' ? '100px' : '150px'
          }"
        />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          [pTooltip]="showTooltip(col.header)"
          *ngFor="let col of columns"
          [pSortableColumn]="col.field"
          pReorderableColumn
          pResizableColumn
          [ngStyle]="{
            textAlign:
              col.type === 'string' || col.type === 'primary'
                ? 'left'
                : col.type === 'any'
                ? 'center'
                : 'right'
          }"
        >
          {{ col.header }}
          <p-sortIcon
            *ngIf="col.type !== 'any'"
            [field]="col.field"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          >
          </p-sortIcon>
        </th>
      </tr>
      <tr *ngIf="isFilter">
        <th class="columnFilterTH" *ngFor="let col of columns">
          <p-overlayPanel
            #op
            [showCloseIcon]="true"
            [dismissable]="true"
            appendTo="th"
          >
            <ng-container *ngIf="col.type === 'number'"
              ><div [ngStyle]="{ float: 'left', display: 'contents' }">
                {{ col.header }}
              </div>
              <div style="margin-bottom: 0.25rem; margin-top: 0.5rem;">
                <input
                  [attr.id]="col.field + '_greater_than'"
                  *ngIf="isFilter"
                  (keyup)="dt.filter(col.field, col.field, 'filterNumber')"
                  (change)="updateFilterOptions(dt.filteredValue, col.field)"
                  pInputText
                  type="text"
                  placeholder="Greater Than"
                />
              </div>
              <div style="margin-bottom: 0.25rem;">
                <input
                  [attr.id]="col.field + '_less_than'"
                  *ngIf="isFilter"
                  (keyup)="dt.filter(col.field, col.field, 'filterNumber')"
                  (change)="updateFilterOptions(dt.filteredValue, col.field)"
                  pInputText
                  type="text"
                  placeholder="Less Than"
                />
              </div>
            </ng-container>
            <ng-container
              *ngIf="col.type === 'string' || col.type === 'primary'"
            >
              <div [ngStyle]="{ float: 'left', display: 'contents' }">
                {{ col.header }}
              </div>
              <div style="margin-bottom: 0.25rem; margin-top: 0.5rem;">
                <input
                  [attr.id]="col.field + '_starts_with'"
                  *ngIf="isFilter"
                  (keyup)="dt.filter(col.field, col.field, 'filterString')"
                  (change)="updateFilterOptions(dt.filteredValue, col.field)"
                  pInputText
                  type="text"
                  placeholder="Starts With"
                />
              </div>
              <div style="margin-bottom: 0.25rem;">
                <input
                  [attr.id]="col.field + '_ends_with'"
                  *ngIf="isFilter"
                  (keyup)="dt.filter(col.field, col.field, 'filterString')"
                  (change)="updateFilterOptions(dt.filteredValue, col.field)"
                  pInputText
                  type="text"
                  placeholder="Ends With"
                />
              </div>
            </ng-container>
            <div>
              <p-multiSelect
                appendTo="body"
                [filter]="isFilter"
                [options]="filterOptions[col.field]"
                [style]="{ width: '100%' }"
                defaultLabel=""
                (onChange)="dt.filter($event.value, col.field, 'in')"
                (onPanelHide)="updateFilterOptions(dt.filteredValue, col.field)"
              ></p-multiSelect>
            </div>
          </p-overlayPanel>
          <p-button
            class="openAdvanceFilterPanel"
            label="⟱"
            (click)="op.toggle($event)"
          ></p-button>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td
          [pTooltip]="showTooltip(rowData[col.field])"
          *ngFor="let col of columns"
          [ngStyle]="{
            textAlign:
              col.type === 'string' || col.type === 'primary'
                ? 'left'
                : col.type === 'any'
                ? 'center'
                : 'right'
          }"
        >
          <span *ngIf="col.type !== 'any'">
            {{ rowData[col.field] }}
          </span>
          <span *ngIf="col.type === 'any' && rowData['network_name']">
            <button
              mat-button
              pTooltip="Rename Network Name"
              (click)="op.show($event); networkName = rowData['network_name']"
            >
              <img
                src="assets/icons/rename_w.svg"
                [style]="{ width: '16px' }"
              />
            </button>
            <button
              mat-button
              pTooltip="Edit"
              (click)="editNetworkDetails(rowData)"
            >
              <img
                src="assets/icons/edit_w.svg"
                [style]="{ width: '14px', 'margin-left': '.3rem' }"
              />
            </button>
          </span>
          <p-overlayPanel
            #op
            [autoZIndex]="true"
            [dismissable]="true"
            appendTo="body"
          >
            <div [ngStyle]="{ 'margin-bottom': '.5rem' }">
              Rename Network Name
            </div>
            <div [ngStyle]="{ 'margin-bottom': '.5rem' }">
              <textarea
                [rows]="1"
                [cols]="30"
                pInputTextarea
                [(ngModel)]="networkName"
                autoResize="autoResize"
              ></textarea>
            </div>
            <div>
              <button
                pButton
                [ngStyle]="{
                  'background-color': '#e25750',
                  'border-color': '#e25750',
                  'margin-right': '1rem'
                }"
                (click)="renameNetworkName(rowData)"
                type="button"
                label="Rename"
              ></button>
              <button
                pButton
                (click)="op.hide()"
                type="button"
                label="Close"
              ></button>
            </div>
          </p-overlayPanel>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <span *ngIf="(dt._value | json) !== '[]'">
        Showing {{ (dt._totalRecords !== 0 ? dt._first : 0) | json }}&#8210;{{
          (dt._first + dt._rows < dt._totalRecords
            ? dt._rows + dt._first
            : dt._totalRecords
          ) | json
        }}
        entries
        {{
          isFilter || isGlobalFilter
            ? "(" + dt._totalRecords + " filtered records)"
            : ""
        }}
        from
        {{ (data.data !== undefined ? data.data.length : 0) | json }} records
      </span>
    </ng-template>
  </p-table>
</div>
<p-toast
  [style]="{ marginTop: '50px', marginRight: '-15px' }"
  styleClass="custom-toast"
  position="top-right"
  key="tc"
></p-toast>
